import { createToast } from './createToast';

// Funções exclusivas do toast global do outbox (upload em segundo plano).
// Toasts "normais" de qualquer outra feature devem usar estado local +
// as funções de utils/createToast.js — nunca este arquivo.

const FIXED_PENDING_ID = 'outbox-pending';

export const createPendingToast = (setToastList, message) => {
  setToastList(prevState => {
    const alreadyExists = prevState.find(t => t.id === FIXED_PENDING_ID);

    if (alreadyExists) return prevState;

    return [
      ...prevState,
      {
        ...createToast({
          type: 'loading',
          message,
        }),
        id: FIXED_PENDING_ID,
        autoDelete: false,
      },
    ];
  });
};

export const removePendingToast = setToastList => {
  setToastList(prev => prev.filter(t => t.id !== FIXED_PENDING_ID));
};

export const removeErrorToasts = setToastList => {
  setToastList(prev => prev.filter(t => t.type !== 'error'));
};
